import React, { useState, useEffect } from "react";
import { useAuth, API } from "../App";
import axios from "axios";
import { Layout } from "../components/Layout";
import { UserCard } from "../components/UserCard";
import { Input } from "../components/ui/input";
import { Skeleton } from "../components/ui/skeleton";
import { Search, Users } from "lucide-react";

const SearchPage = () => {
  const { token } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    const searchUsers = async () => {
      if (!searchQuery.trim()) {
        setUsers([]);
        setHasSearched(false);
        return;
      }

      setLoading(true);
      setHasSearched(true);

      try {
        const response = await axios.get(`${API}/users`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { search: searchQuery, limit: 20 }
        });
        setUsers(response.data);
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(searchUsers, 300);
    return () => clearTimeout(debounce);
  }, [searchQuery, token]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="animate-fadeIn">
          <h1 className="text-2xl sm:text-3xl font-extrabold mb-1 text-slate-900" style={{ fontFamily: 'Outfit' }}>
            Rechercher
          </h1>
          <p className="text-slate-500 mb-6">
            Trouvez des utilisateurs à évaluer
          </p>

          {/* Search Input */}
          <div className="relative">
            <Search 
              size={20} 
              className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" 
            />
            <Input
              type="text"
              placeholder="Rechercher par nom ou email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-12 h-14 rounded-2xl text-base"
              data-testid="search-input"
            />
          </div>
        </div>

        {/* Results */}
        <div className="space-y-4 animate-fadeIn stagger-1">
          {loading ? (
            <>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} className="h-24 w-full rounded-2xl" />
              ))}
            </>
          ) : users.length > 0 ? (
            users.map((user) => (
              <UserCard key={user.id} user={user} />
            ))
          ) : hasSearched ? (
            <div className="empty-state py-12">
              <Users size={48} className="empty-state-icon" />
              <p className="font-medium">Aucun utilisateur trouvé</p>
              <p className="text-sm mt-1">Essayez avec d'autres termes</p>
            </div>
          ) : (
            <div className="empty-state py-12">
              <Search size={48} className="empty-state-icon" />
              <p className="font-medium">Commencez à taper</p>
              <p className="text-sm mt-1">Recherchez par nom ou email</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default SearchPage;
